import Tenants from 'components/tenants/Tenants';
import Applications from 'components/Applications';
import TenantDetails from 'components/tenants/TenantDetails';
import TenantSettings from 'components/tenants/TenantSettings';
import { IMenuRoute } from 'interfaces/menu-route';
import ChangePassword from 'components/ChangePassword';
import MFASettings from 'components/MFASettings';

const routes : Array<IMenuRoute> = [
  {
    path: "/tenants",
    name: "Tenants",
    component: Tenants,
    icon: "tim-icons icon-chart-pie-36",
    layout: "/admin",
    display: true
  },
  {
    path: "/tenantdetails",
    name: "Tenant Details",
    component: TenantDetails,
    icon: "tim-icons icon-chart-pie-36",
    layout: "/admin",
    display: false
  },
  {
    path: "/tenantsettings",
    name: "Tenant Settings",
    component: TenantSettings,
    icon: "tim-icons icon-chart-pie-36",
    layout: "/admin",
    display: false
  },
  {
    path: "/applications",
    name: "Applications",
    component: Applications,
    icon: "tim-icons icon-chart-pie-36",
    layout: "/admin",
    display: true
  },
  {
    path: '/change-password',
    name: 'Change Password',
    component: ChangePassword,
    icon: 'tim-icons icon-chart-pie-36',
    layout: '/admin',
    display: false,
  },
  {
    path: '/mfa-settings',
    name: 'MFA Settings',
    component: MFASettings,
    icon: 'tim-icons icon-chart-pie-36',
    layout: '/admin',
    display: false,
  }
];

export default routes;
